<template>
  <PageContent class="summary-page">
    <span class="summary-title">
      Please review and confirm your submission
    </span>
    <PanelV2
      type="w8"
      :title="sections[0].name"
      @nextClick="toNext()"
      mode="simple"
    >
      <template v-if="ekycStatus=='0'" v-slot:title-solt>
        <span class="btn-action" @click="toEdit(1)">EDIT</span>
      </template>
      <template v-slot:content-solt>
        <InfoBox
          :formdata="sections[0].data"
          :series="sections[0].columns.length"
        ></InfoBox>
      </template>
    </PanelV2>

    <PanelV2
      type="w8"
      :title="sections[1].name"
      @nextClick="toNext()"
      mode="simple"
    >
      <template v-if="ekycStatus=='0'" v-slot:title-solt>
        <span class="btn-action" @click="toEdit(2)">EDIT</span>
      </template>
      <template v-slot:content-solt>
        <InfoBox
          :formdata="sections[1].data"
          :series="sections[1].columns.length"
        ></InfoBox>
      </template>
    </PanelV2>

    <PanelV2
      type="w8"
      :title="sections[2].name"
      @nextClick="toNext()"
      mode="simple"
    >
      <template v-if="ekycStatus=='0'" v-slot:title-solt>
        <span class="btn-action" @click="toEdit(3)">EDIT</span>
      </template>
      <template v-slot:content-solt>
        <InfoBox
          :formdata="sections[2].data"
          :series="sections[2].columns.length"
          :agreements="agreementData"
        ></InfoBox>
      </template>
    </PanelV2>

    <div class="with-two-panel">
      <PanelV2
        width="532px"
        :title="sections[3].name"
        @nextClick="toNext()"
        mode="simple"
      >
        <template v-if="ekycStatus=='0' || !documentPsAreas.every(item=>!sections[3].isEditList.includes(item))" v-slot:title-solt>
          <span class="btn-action" @click="toEdit(4)">EDIT</span>
        </template>
        <template v-slot:content-solt>
          <InfoBox
            :formdata="sections[3].data"
            :series="sections[3].columns.length"
          ></InfoBox>
        </template>
      </PanelV2>

      <PanelV2
        width="532px"
        :title="sections[4].name"
        @nextClick="toNext()"
        mode="simple"
      >
        <template v-if="ekycStatus=='0' || !documentPsAreas.every(item=>!sections[4].isEditList.includes(item))" v-slot:title-solt>
          <span class="btn-action" @click="toEdit(5)">EDIT</span>
        </template>
        <template v-slot:content-solt>
          <InfoBox
            :formdata="sections[4].data"
            :series="sections[4].columns.length"
          ></InfoBox>
        </template>
      </PanelV2>
    </div>

    <div class="summary-el-button-line">
      <el-button @click="$router.go(-1)">Back</el-button>
      <el-button type="primary" @click="doConfirm()">Confirm</el-button>
    </div>
  </PageContent>
</template>

<script>
import InfoBox from "../components/InfoBox";
import { dateFormat } from "../../plugins/utils";
import API from "@/api";
// import { doProcessing } from "@/common-data/config.js";

export default {
  name: "IndividualL",
  pRouter: "IndividualK",
  components: {
    InfoBox,
  },
  data() {
    return {
      formData: {},
      sections: [
        {
          name: "BDO Payment Solutions",
          editEntry: "/edit-payment",
          columns: ["digitalPayment", "physicalPayment", ""],
          data: { left: [], middle: [], right: [] },
        },
        {
          name: "Personal Information",
          editEntry: "/edit-personal-info",
          columns: ["personalInfo", "homeAddress", "additionalDetails"],
          data: { left: [], middle: [], right: [] },
        },
        {
          name: "Business Information",
          editEntry: "/edit-business-ino",
          columns: [
            "businessDetails",
            "businessAddress",
            "businessOnlineStore",
          ],
          data: { left: [], middle: [], right: [] },
        },
        {
          name: "BDO Settlement Account",
          editEntry: "/edit-settlement",
          columns: ["settlementAccount"],
          data: { left: [], middle: [], right: [] },
        },
        {
          name: "Document Submission",
          editEntry: "/edit-document",
          columns: ["selfieWithIDPhoto", "secPhoto"],
          data: { selfie: [], exterior: [], interior: [] },
        },
      ],

      agreementData: {},
      documentPsAreas: [],
      ekycStatus: '',
    };
  },
  created() {
    API.getBdoProcessData({
      ...this.formatCommitData(),
    }).then((res) => {
      this.formData = res.obj
      //ekycStatus 0初始化，1待初审，2待复审，3审核通过，4待补充资料，5审核不通过，6需再次审核
      const { personalInfo, documentPsAreas=[], ekycStatus='0', processNo, businessDetails } = res.obj || {}
      const { newMchNameAgreement, privacyAgreementTime, merchantAgreementTime } = personalInfo || {}
      const { businessName } = businessDetails || {}
      this.agreementData = {
        'newMchNameAgreement': newMchNameAgreement || '',
        'privacyAgreementTime': dateFormat(privacyAgreementTime),
        'merchantAgreementTime': dateFormat(merchantAgreementTime),
        processNo: processNo || '1',
        registeredBusinessName: businessName,
      }
      this.documentPsAreas = documentPsAreas
      this.ekycStatus = ekycStatus
      this.formatColumn()
    });
  },
  methods: {
    toEdit(e) {
      let addr = "";
      switch (e) {
        case 1:
          addr = "edit-payment";
          break;
        case 2:
          addr = "/edit-personal-info";
          break;
        case 3:
          addr = "/edit-business-info";
          break;
        case 4:
          addr = "/edit-settlement";
          break;
        case 5:
          addr = "/edit-document";
          break;
      }
      this.$router.push({ path: addr });
    },
    doConfirm() {
      API.confirmBdoProcess({
        processNo: this?.formData?.processNo || '1',
        token: this.getCookieItem("token"),
      }).then((res) => {
        if (res.success) {
          this.$router.push({ path: "/finish-process" });
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.page-content {
  .btn-action {
    cursor: pointer;
  }
  flex-direction: column;
  .panel-v2.content-area {
    margin: 8px 0;
    height: 100%;
  }
  .summary-title {
    align-self: start;
    margin-top: 48px;
    margin-bottom: 16px;
    width: 100%;
    text-align: left;
    font: normal normal normal 20px/24px Nunito-bold;
    letter-spacing: 0px;
    color: #2e2e2e;
  }
  .with-two-panel {
    display: flex;
    justify-content: space-between;
    width: 100%;
    .panel-v2.content-area {
      margin: 16px 0;
      height: 100%;
    }
  }
  .summary-el-button-line {
    display: flex;
    width: 100%;
    height: 112px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 16px #00000014;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
  }
}
</style>
